import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/service/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator, MatTableDataSource, MatDatepickerModule, MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDatepickerInputEvent } from '@angular/material';
import { Select2OptionData } from 'ng-select2';
import {Options} from 'select2';
import * as _moment from 'moment';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { numValidation } from 'src/app/service/customValidation';
import { panCard, mobile, email } from '../../service/customValidation';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { DataPassingService } from 'src/app/service/data-passing.service';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface StandardElement {
  name: string;
  installment: string;
  amount: string;
  action: any;
}
@NgModule({
  imports:[
    MatDatepickerModule,
    MatNativeDateModule
  ]
})

@Component({
  selector: 'app-donar',
  templateUrl: './donar.component.html',
  styleUrls: ['./donar.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class DonarComponent implements OnInit {
  maxValid=false;
  maxDate=new Date();
  public donarType: Array<Select2OptionData>;
  public desgData: Array<Select2OptionData>;
  deviceList:Array<Select2OptionData>;
  martialList:Array<Select2OptionData>;
  public options: Options;
  displayedColumns: string[] = ['name', 'designation','action'];
  dataSource:MatTableDataSource<StandardElement>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isTable=true;
  editMode=false;
  isForm=false;
  isSuccess=false;
  isEditLoading=false;
  isError=false;
  isSubmitted=false;
  isDisabled=false;
  message:string='';
  tblLoading=false;
  isAdopt=false;
  itemTotal=0;
  inputFormGroup:FormGroup;
  editData:any=[];
  searching = false;
  searchFailed = false;
  isAdobpt=false;
  validAmount=false;
  fundList:any;
  constructor(private formBuilder:FormBuilder,private api:ApiService,private route:ActivatedRoute,private datepipe:DatePipe,private dataPass:DataPassingService,private router:Router) {
    this.inputFormGroup=this.formBuilder.group({
      id:[0],
      fundType:['',Validators.required],
      first_name: ['', Validators.required],
      middle_name: ['', Validators.required],
      last_name: ['', Validators.required],
      gender:['Male',Validators.required],
      dob:[''],
      address:['',Validators.required],
      city:['',Validators.required],
      pancard:['',panCard()],
      mobile:['',[Validators.required,mobile()]],
      email:['',email()],
      maritial_status:[''],
      uidno:[''],
      blood_group:[''],
      doj:[''],
      adopt:['No'],
      studId:[''],
      donateAmount:['']
    });
  }

  ngOnInit() {
    this.dataPass.passData.subscribe(data=>{
     
      
      if(data.id>0)
      {
        this.isEditLoading=true;
        this.api.get('donar?id='+data.id).subscribe((rdata)=>{
          let userData=rdata.data[0];
          let dateb=userData.dob;
          this.editMode=true;
          this.inputFormGroup.patchValue({
            id:userData.user_id,first_name:userData.first_name,middle_name:userData.middle_name,last_name:userData.last_name,gender:userData.gender,dob:userData.dob,address:userData.present_addr,city:userData.place,mobile:userData.mobile,email:userData.email,pancard:userData.pan,donateAmount:'200',fundType:'1',doj:userData.due_date,uidno:userData.uid
          });
          this.isEditLoading=false;
          
        },(error)=>{});
      }
     
    });
    this.martialList=[{id:"single",text:"single"},{id:"Married",text:"Married"},{id:"Widowed",text:"Widowed"},{id:"Divorced",text:"Divorced"}]
    this.options = {
      width: '300',
      multiple: true,
      tags: true
    };

    this.donarType=[];
    this.desgData=[];
    this.deviceList=[];
    this.dataSource.paginator = this.paginator;
    this.route.data.subscribe(data=>{
      this.itemTotal=parseInt(data.employee[0].total);
      this.dataSource.data=data.employee[0].data;
      this.fundList=data.employee[1].data;
      this.fundList.forEach(element => {
        
        var bData={id:element.id,text:element.title};
        this.donarType.push(bData);
      });
      /*data.employee[2].data.forEach(element => {
        var bData={id:element.designation_id,text:element.designation_name};
        this.desgData.push(bData);
      });
      data.employee[3].data.forEach(element => {
        let aData={id:element.device_id,text:element.device_name};
        this.deviceList.push(aData);
      });*/

    },(error)=>{

    });
  }

  searchUser = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => term.length<2 ?[''] :
        this.api.get("searchStudent?search="+term).pipe(
          map((response)=>{if(response.status){
            return response.data.map((item,index)=>{
              return {name:item.name,display:item.name+"("+item.registrationId+")",id:item.id,scholarship:Math.round(item.scholarship/2)};
            })
          }})
          )
      ),
      tap(() => this.searching = false)
    )

    formatter = (x: {name: string}) => x.name;
    rFormatter=(x: {display: string}) => x.display;

    selectedUser(item){
    
      this.inputFormGroup.patchValue({studId:item.item.id,donateAmount:item.item.scholarship});

    }
    

    onAdopt(e)
    {
      if(e.target.value=="Yes")
      {
        this.isAdobpt=true;
      }
      else
      {
        this.isAdobpt=false;
      }

    }

    checkValue(event)
    {
      this.isDisabled=false;
      document.querySelector<HTMLDivElement>(".validAmount").innerHTML="";
      let val=event.target.value
      let typeId=this.inputFormGroup.controls.fundType.value;
      this.fundList.forEach(element => {
        if(element.id==parseInt(typeId))
        {
          if(element.short=="U" && parseInt(val)<50000)
          {
            this.isDisabled=true;
            document.querySelector<HTMLDivElement>(".validAmount").innerHTML="Amount should be more than 50K.";
          }
          else if(element.short=="S" && parseInt(val)<5000)
          {
            this.isDisabled=true;
            document.querySelector<HTMLDivElement>(".validAmount").innerHTML="Amount should be more than or equal to 5K.";
          }
          else if(element.short=="G" && parseInt(val)>=5000)
          {
            this.isDisabled=true;
            document.querySelector<HTMLDivElement>(".validAmount").innerHTML="Amount should be less than 5K.";
          }
          else if(element.short=="T")
          {
            this.isDisabled=false;
            document.querySelector<HTMLDivElement>(".validAmount").innerHTML="";
          }
        }
      });
      
    }

  changePage(event)
  {
    event.preventDefault();
    this.isForm=!this.isForm;
    this.isTable=!this.isTable;
    if(this.isTable)
    {
      this.tableRefresh();
    }
  }

  saveForm(form)
  {
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      form.value.dob=this.datepipe.transform(form.value.dob,"dd/MM/yyyy");
      form.value.doj=this.datepipe.transform(form.value.doj,"dd/MM/yyyy");
      this.api.post(form.value,'donar').subscribe(data=>{
        if(data.status)
        {
          this.dataPass.passDataService({});
          this.message=data.message;
          alert(this.message);
          this.router.navigateByUrl('admin/viewDonar');
        }
        else
        {
          alert(this.message);
          this.message=data.message;
        }
        this.editMode=false;
        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
        this.isAdobpt=false;
        
      },(error)=>{});

    }
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    let postData={start:start,length:event.pageSize};
    this.api.get("donar").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{

    });
  }

  tableRefresh()
  {
    this.api.get("donar").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{});
  }


  deleteRecord(id)
  {
    let postData={id:id};
    this.api.post(postData,"deleteDonar").subscribe(data=>{
      this.tableRefresh();
    },(error)=>{

    });
  }

  dateEvent(type: string, event: MatDatepickerInputEvent<any>) {
    this.isDisabled=false;
    this.maxValid=false;
    let dt=event.value._d;
    let nwDt=new Date();
    if(dt>=nwDt)
    {
      this.isDisabled=true;
      this.maxValid=true;
     
      
    }
  }

}
